import { getLocalConferenceTime } from '../../functions.any';
export function shouldShowUsabillaFeedback(state) {
    // @ts-ignore
    const { usabilla } = state['features/base/config'];
    // @ts-ignore
    return Boolean(!APP.wildix.wizy
        && usabilla?.enabled
        && getLocalConferenceTime(state, 'seconds') > usabilla?.minimumConferenceDuration);
}
export function showUsabillaFeedback(state) {
    // @ts-ignore
    const { isXbees } = state['features/base/config'];
    // @ts-ignore
    isXbees ? APP.xBeesEvents.showUsabillaFeedback() : window?.usabilla_live('trigger', 'manual trigger wizy');
}
